<template>
    <div class="body-inner">
        <header-landing-component></header-landing-component>


        <div id="slider" class="inspiro-slider dots-creative" data-height-xs="360">
            <!-- Slide 2 -->
            <div class="slide kenburns" style="background-image:url('../../assets/images/autodesk_bg_banner.jpg');">
                <div class="bg-overlay"></div>
                <div class="container">
                    <div class="slide-captions text-center text-light">
                        <!-- Captions -->
                        <span class="strong">Certificaciones</span>
                        <h1>Autodesk Certified User<br>
<span style="font-size: 2.55rem"></span></h1>
                        <!-- end: Captions -->
                    </div>
                </div>
            </div>
            <!-- end: Slide 2 -->

        </div>
        <!--end: Inspiro Slider -->

        <section>
            <div class="container">
                <div class="row">
                    <div class="col-lg-4">
                        <div class="heading-text heading-section">
                            <h2 style="font-size: 2.85rem">DISEÑA Y CREA UN MUNDO MEJOR</h2>

                        </div>
						<img src="../../assets/images/certificaciones/autodesk.png" class="mb-4">
                    </div>
                    <div class="col-lg-8">
                        <div class="row">
                            <div class="col-lg-10">
								
							<p>Las sólidas habilidades el en uso de software de diseño 2D y 3D son un gran activo tanto en el ámbito académico como en el profesional. <br>
<br>
Enseñar a los estudiantes a usar el software de diseño de Autodesk de última generación, como AutoCAD, Inventor, Revit, Maya, 3DS Max y Fusion 360, les brinda una ventaja significativa para lograr el éxito universitario o profesional.</p>
								
								<p>La certificación <strong>Autodesk Certified User</strong> confirma que los estudiantes tienen las habilidades necesarias para continuar sus carreras de diseño, ya sea que asistan a la universidad, ingresen a la industria o trabajen hacia niveles adicionales de certificación, esta certificación proporciona una credencial reconocida a nivel internacional que prueba su nivel de dominio en el manejo del software 2D y 3D ayudándole a destacar sobre la competencia.</p>
								
							  <hr>
								<br>
								
								<h4>BENEFICIOS DE LA CERTIFICACIÓN</h4>
								
								<ul class="list-icon list-icon-check">
									<li>Las personas que aprueban un examen de certificación de Autodesk reciben un certificado electrónico con respaldo internacional y que puede validarse a través del portal Certiport para que las escuelas y los empleadores puedan validar fácilmente su certificación.</li>

<li>También pueden reclamar una insignia de certificación digital oficial para promocionar en las redes sociales, correo electrónico y carteras en línea.</li>

<li>La insignia de certificación les da la capacidad de compartir sus habilidades en línea de una manera simple, confiable y que se puede verificar fácilmente en tiempo real.</li>
								
								</ul>
							
							
							</div>

                         

                        </div>
                    </div>

                </div>
                <div class="row mt-5">
                    <div class="col-12 text-center">
                        <p class="gca-title-big">CERTIFICADO OFICIAL</p>
                    </div>
                    <div class="col-12 text-center">
                        <img src="../../assets/images/carousel/Autodesk_Sample_Certificate.png" alt="">
                    </div>
                </div>
            </div>
        </section>

		
		<section>
		 <div class="container">
			 
            <div class="row">
				
				<div class="col-md-6"><h2>EXÁMENES DISPONIBLES AUTODESK CERTIFIED USER</h2></div>
				
				<div class="col-md-6">
					
					<img src="../../assets/images/examenes-autodesk.png">
					
					
					
					
			   </div>
				
				
                
              
               
            </div>
		 </div>
        </section>

      

        <!--call-to-action dark -->
        <div class="call-to-action p-t-100 p-b-100  mb-0 call-to-action-dark">
            <div class="container">
                <div class="row">
                    <div class="col-lg-10">
                        <h3>
                            ¿Quieres agregar esta credencial con validez internacional a tu CV?
                        </h3>
                        <p>
                            Conoce todas las soluciones que Global Certification Academy ofrece para agregar VALOR A TU CURRÍCULUM.
                        </p>
                    </div>
                    <div class="col-lg-2"><router-link class="btn btn-primary btn-lg" to="/register">INSCRIBIRME</router-link></div>
                </div>
            </div>
        </div>
        <!--end: call-to-action dark -->
        <LeadComponent></LeadComponent>
        <footer-landing-component></footer-landing-component>

     
    </div>
</template>

<script>
    import HeaderLandingComponent from "../../components/Landing/HeaderLandingComponent.vue"
    import FooterLandingComponent from "../../components/Landing/FooterLandingComponent.vue"
    import LeadComponent from "../../components/Landing/LeadComponent.vue"
	export default {
		name: 'autodesk',
        components: {
			HeaderLandingComponent,
            FooterLandingComponent,
            LeadComponent
		},   
		data() {
			return {
            }
        },
		methods: {
        },
		mounted() {
        }        
    }

</script>